export function RegistrationTemplateLogic( categoryXml, childParentAttribute, child ) {
    if (childParentAttribute === "registration-template") {
      console.log("All Blocks:::::", Blockly.Blocks);
      console.log("childParentAttribute:", childParentAttribute);
  
      console.log("Child HTML Structure:", child);
  
      // Extract all input fields and buttons within the registration-template
      const fields = Array.from(child.getElementsByTagName("input"));
      const buttonComponent = Array.from(child.getElementsByTagName("button"));
      console.log("Button Component", buttonComponent);
      let fieldCounter = 1;
  
      const allFieldBlocks = [];
  
      const button = buttonComponent[0];
  
      //Component Instance block for button
      Blockly.Blocks[`component_instance-${button.tagName}-${button.id}`] = {
        init: function () {
          this.appendDummyInput().appendField(
            `Component Instance-${button.tagName}-${button.id}`
          );
          this.appendStatementInput("Properties");
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(43);
          this.setTooltip("Get Instance of the Component");
        },
      };
  
      Blockly.JavaScript[`component_instance-${button.tagName}-${button.id}`] =
        function (block) {
          const properties = Blockly.JavaScript.statementToCode(
            block,
            "Properties"
          );
  
          var code = `
          var childElement${button.id} = document.querySelector("#${button.id}");
          if(childElement${button.id}){
              ${properties}
          }
          `;
  
          return code;
        };
  
      //Component events block for button
      Blockly.Blocks[`events-${button.tagName}-${button.id}`] = {
        init: function () {
          this.appendDummyInput().appendField(
            `Component Events-${button.tagName}-${button.id}`
          );
          this.appendDummyInput()
            .appendField("On Event")
            .appendField(
              new Blockly.FieldDropdown([
                ["Click", "click"],
                ["Change", "change"],
              ]),
              "EVENT"
            );
          this.appendStatementInput("DO").appendField("Do");
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(230);
          this.setTooltip("Add event handler To the component");
          this.setHelpUrl("");
        },
      };
  
      Blockly.JavaScript[`events-${button.tagName}-${button.id}`] = function (
        block
      ) {
        var event = block.getFieldValue("EVENT");
        var code = "";
        var actionCode = Blockly.JavaScript.statementToCode(block, "DO");
  
        if (event && actionCode) {
          code += `
                
                    childElement${button.id}.addEventListener('${event}', function(event) {
                      ${actionCode}
                    });
                
                `;
        }
  
        return code;
      };
  
      fields.forEach((field, index) => {
        const fieldId = field.id;
        const fieldTag = field.tagName;
        const variableName = `field${fieldCounter}`;
  
        //Component Instance block for each field
        const blockTypeInstance = `component_instance-${fieldTag}-${fieldId}`;
        Blockly.Blocks[blockTypeInstance] = {
          init: function () {
            this.appendDummyInput().appendField(
              `Component Instance of ${fieldTag}-${fieldId}`
            );
            this.appendStatementInput("Properties");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(43);
            this.setTooltip("Get Instance of the input field.");
          },
        };
  
        Blockly.JavaScript[blockTypeInstance] = function (block) {
          const properties = Blockly.JavaScript.statementToCode(
            block,
            "Properties"
          );
  
          var code = `
          var childElement${fieldId} = document.querySelector("#${fieldId}");
          if(childElement${fieldId}){
            ${properties}
          }
          `;
  
          return code;
        };
  
        //Component events block for each field
        const blockTypeEvents = `events-${fieldTag}-${fieldId}`;
        Blockly.Blocks[blockTypeEvents] = {
          init: function () {
            this.appendDummyInput().appendField(
              `Component Events for ${fieldTag}-${fieldId}`
            );
            this.appendDummyInput()
              .appendField("On Event")
              .appendField(
                new Blockly.FieldDropdown([
                  ["Change", "change"],
                  ["Click", "click"],
                ]),
                "EVENT"
              );
            this.appendStatementInput("DO").appendField("Do");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(262);
            this.setTooltip("Add event handler to the component.");
            this.setHelpUrl("");
          },
        };
  
        Blockly.JavaScript[blockTypeEvents] = function (block) {
          var event = block.getFieldValue("EVENT");
          var code = "";
          var actionCode = Blockly.JavaScript.statementToCode(block, "DO");
  
          if (event && actionCode) {
            code += `
              
              childElement${fieldId}.addEventListener('${event}', function(event) {
                ${actionCode}
              });
              
            `;
          }
  
          return code;
        };
  
        //Target property block for each field
        const blockTypeTargetProperty = `target-property-${fieldTag}-${fieldId}`;
        Blockly.Blocks[blockTypeTargetProperty] = {
          init: function () {
            this.appendDummyInput().appendField(
              `target-property-${fieldTag}-${fieldId}`
            );
            this.setOutput(true, "String");
            this.setColour(230);
            this.setTooltip(
              `Get the event value of the ${fieldTag}-${fieldId} Input`
            );
            this.setHelpUrl("");
          },
        };
  
        Blockly.JavaScript[blockTypeTargetProperty] = function (block) {
          // const code = `document.querySelector("#${fieldId}").value`;
          const code = "event.target.value";
          return [code, Blockly.JavaScript.ORDER_ATOMIC];
        };
  
        //Customise styles of block for each field
        Blockly.Blocks[`custom_css_property-${fieldTag}-${fieldId}`] = {
          init: function () {
            this.appendDummyInput().appendField(
              `Customise styles of ${fieldTag}-${fieldId}`
            );
            this.appendValueInput("PROPERTY_NAME")
              .setCheck("String")
              .appendField("Property Name:");
  
            this.appendValueInput("PROPERTY_VALUE")
              .setCheck("String")
              .appendField("Value:");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(180);
            this.setTooltip("Specify a CSS property, its type, and value.");
          },
        };
  
        Blockly.JavaScript[`custom_css_property-${fieldTag}-${fieldId}`] =
          function (block) {
            const propertyName = Blockly.JavaScript.valueToCode(
              block,
              "PROPERTY_NAME",
              Blockly.JavaScript.ORDER_ATOMIC
            );
  
            const propertyValue = Blockly.JavaScript.valueToCode(
              block,
              "PROPERTY_VALUE",
              Blockly.JavaScript.ORDER_ATOMIC
            );
  
            var code = `
            childElement${fieldId}.style[${propertyName}]=${propertyValue}
          `;
  
            return code;
          };
  
        const fieldBlocks = `
    <block type="${blockTypeInstance}">
      <statement name="Properties">
        <block type="${blockTypeEvents}">
          <field name="EVENT">change</field>
          <statement name="DO">
            <block type="controls_if">
              <mutation else="1"></mutation>
              <value name="IF0">
                <block type="logic_compare">
                  <field name="OP">GT</field>
                  <value name="A">
                    <block type="lists_length">
                      <value name="VALUE">
                        <block type="${blockTypeTargetProperty}"></block>
                      </value>
                    </block>
                  </value>
                  <value name="B">
                    <block type="math_number">
                      <field name="NUM">0</field>
                    </block>
                  </value>
                </block>
              </value>
              <statement name="DO0">
                <block type="variables_set">
                  <field name="VAR">${variableName}</field>
                  <value name="VALUE">
                    <block type="${blockTypeTargetProperty}"></block>
                  </value>
                </block>
              </statement>
              <statement name="ELSE">
                <block type="custom_css_property-${fieldTag}-${fieldId}">
                  <value name="PROPERTY_NAME">
                    <block type="text">
                      <field name="TEXT">border</field>
                    </block>
                  </value>
                  <value name="PROPERTY_VALUE">
                    <block type="text">
                      <field name="TEXT">1px solid red</field>
                    </block>
                  </value>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </statement>
      ${index < fields.length - 1 ? "<next></next>" : ""}
    </block>
  `;
  
        allFieldBlocks.push(fieldBlocks);
  
        fieldCounter++;
      });
  
      // let xmlString = "";
      // Object.keys(Blockly.Blocks).forEach((blockType) => {
      //   xmlString += `<block type="${blockType}"></block>\n`;
      // });
  
      // // Log the converted XML format
      // console.log("Converted XML format:", xmlString);
  
      let combinedFieldBlocks = "";
      for (let i = allFieldBlocks.length - 1; i >= 0; i--) {
        if (i === allFieldBlocks.length - 1) {
          combinedFieldBlocks = allFieldBlocks[i];
        } else {
          combinedFieldBlocks = allFieldBlocks[i].replace(
            "<next></next>",
            `<next>${combinedFieldBlocks}</next>`
          );
        }
      }
  
      categoryXml += `
        <block type="registration-template-${child.id}">
          <statement name="DO1">
            ${combinedFieldBlocks}
          </statement>
          <statement name="DO3">
        <block type="component_instance-${button.tagName}-${button.id}">
          <statement name="Properties">
            <block type="events-${button.tagName}-${button.id}">
              <field name="EVENT">click</field>
              <statement name="DO">
                // <block type="api_call_V2"></block>
                <block type="api_call">
                  <value name="URL">
                    <block type="text">
                      <field name="TEXT">https://jsonplaceholder.typicode.com/posts</field>
                    </block>
                  </value>
                  <statement name="USER_LOGIC_SUCCESS">
                    <block type="text_print">
                      <value name="TEXT">
                        <shadow type="text">
                          <field name="TEXT">API Called</field>
                        </shadow>
                      </value>
                    </block>
                  </statement>
                  <value name="RESPONSE_VARIABLE">
                    <block type="variables_get">
                      <field name="VAR">apiResponse</field>
                    </block>
                  </value>
                </block>
              </statement>
            </block>
          </statement>
        </block>
      </statement>
        </block>
      `;
  
      // Registration template block definition
      Blockly.Blocks[`registration-template-${child.id}`] = {
        init: function () {
          this.appendDummyInput().appendField("Registration Template Block");
  
          // First insertion point (Do block 1)
          this.appendStatementInput("DO1")
            .setCheck(null)
            .appendField("Do set variables");
  
          // Second insertion point (Do block 2)
          this.appendStatementInput("DO2")
            .setCheck(null)
            .appendField("Do add validations");
  
          // Third insertion point (Do block 3)
          this.appendStatementInput("DO3")
            .setCheck(null)
            .appendField("Do make API call");
  
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(180); // Light blue
          this.setTooltip(
            "Registration Template Block with predefined and custom logic insertion points."
          );
          this.setHelpUrl("");
        },
      };
  
      // Generator function for the registration template block
      Blockly.JavaScript[`registration-template-${child.id}`] = function (block) {
        const do1Logic = Blockly.JavaScript.statementToCode(block, "DO1");
        const do2Logic = Blockly.JavaScript.statementToCode(block, "DO2");
        const do3Logic = Blockly.JavaScript.statementToCode(block, "DO3");
  
        let code = `
          // Variables setting logic
          ${do1Logic}
      
          // Validation logic
          ${do2Logic}
      
          // API call logic
          ${do3Logic}
        `;
        return code;
      };
    }
  
    return categoryXml;
  }
  